import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";
import {MatIcon} from "@angular/material/icon";

import {FormsModule, ReactiveFormsModule} from "@angular/forms";

@Component({
    selector: 'app-clm-performance-header-input',
    imports: [MatIcon, ReactiveFormsModule, FormsModule],
    templateUrl: './clm-performance-header-input.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './clm-performance-header-input.component.css'
})
export class ClmPerformanceHeaderInputComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  espSelection!: GuruEntity;
  altitudeSelection!: GuruEntity;
  fluidTypeSelection!: GuruEntity;
  antifreezeConcentrationSelection!: GuruEntity;
  fanSpeedSelection!: GuruEntity;
  loadInputSelection!: GuruEntity;
  loadFluidFlowSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.PERFORMANCE_INPUTS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.espSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFESP');
    this.altitudeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USAltitude');
    this.fluidTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCFluid');
    this.antifreezeConcentrationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCFluidMix');
    this.fanSpeedSelection = SelectionUtils.getEntity(this.selectionEntities(), "USFanSpeed");
    this.loadInputSelection = SelectionUtils.getEntity(this.selectionEntities(), "USLoadType");
    this.loadFluidFlowSelection = SelectionUtils.getEntity(this.selectionEntities(), "USLFR");
  }

  textSelectionChanged(entity: GuruEntity): void {
    this.selectionChanged(entity, entity.Value);
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
